export default function(event, el) {
  var rect = el.getBoundingClientRect();
  return [
    event.clientX - rect.left - (el.clientLeft || 0),
    event.clientY - rect.top - (el.clientTop || 0)
  ];
}



// WEBPACK FOOTER //
// ./~/vega-scenegraph/src/util/point.js